<template>
    <div>
        <div v-if="series && options">
            <apexchart
                type="pie"
                :height="height"
                :options="options"
                :series="series"
            ></apexchart>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        this.options = this.chartOptions;
        this.series = this.seriesData;
        // this.$forceUpdate();
    },
    props: ["chartOptions", "seriesData", "height"],
    data() {
        return {
            series: [0,100],
            options: {}
        };
    },
    methods: {},
    watch: {
        chartOptions(val) {
            this.options = val;
        },
        seriesData(val) {
            this.series = val;
        }
    }
};
</script>

<style>
</style>